import * as T from '@/types'
import { Location } from 'vue-router'

////////////////////////////////////////////////////////////////
// toasts
////////////////////////////////////////////////////////////////

export interface Toast {
    message?: string
    formattedMessage?: T.FormattedText
    actions?: T.ToastAction[]
    
    createdAt?: T.UnixTimestampMs
}

export interface ToastAction {
    label: string
    onClick: () => void
}

////////////////////////////////////////////////////////////////
// notification text
////////////////////////////////////////////////////////////////

export interface FormattedTextItem {
    text?: string | null
    break?: boolean

    emphasise?: boolean
    name?: boolean
    title?: boolean
    quote?: boolean
    link?: T.Dictionary<any>
    route?: any
    code?: boolean

    truncate?: boolean
    doNotBreak?: boolean

    primary?: boolean
    success?: boolean
    danger?: boolean
    subtle?: boolean
}

export type FormattedText = (T.FormattedTextItem | null | undefined | false)[]

////////////////////////////////////////////////////////////////
// grid layout
////////////////////////////////////////////////////////////////

export interface GridLayoutItem<Key = any> {
    x: number
    y: number
    w: number
    h: number
    i: Key
}

export enum GridBreakpoint {
    XXS = 'xxs',
    XS = 'xs',
    SM = 'sm',
    MD = 'md',
    LG = 'lg',
}

export type GridLayout<Key = any> = GridLayoutItem<Key>[]
